export interface Trip {
    id: string;
    title: string;
    subtitle?: string;
    date: string;
    photos: string[];
}

// Smaller preview version of a photo, generated by scripts/photo-thumbs.sh.
// The full-size path is still used for the lightbox.
export function thumbOf(src: string) {
    const i = src.lastIndexOf("/");
    return `${src.slice(0, i)}/thumb${src.slice(i)}`;
}

// the small version for the preview strip (scripts/photo-thumbs.sh)
export function stripOf(src: string) {
    const i = src.lastIndexOf("/");
    return `${src.slice(0, i)}/strip${src.slice(i)}`;
}

export const trips: Trip[] = [
    {
        id: "lochs-and-glens-way",
        title: "Lochs and Glens Way",
        subtitle: "Cycling from Inverness—Glasgow",
        date: "Jul 2026",
        photos: [
            "/photos/lochs-and-glens-way/01.jpg",
            "/photos/lochs-and-glens-way/02.jpg",
            "/photos/lochs-and-glens-way/03.jpg",
            "/photos/lochs-and-glens-way/04.jpg",
            "/photos/lochs-and-glens-way/05.jpg",
            "/photos/lochs-and-glens-way/06.jpg",
            "/photos/lochs-and-glens-way/07.jpg",
            "/photos/lochs-and-glens-way/08.jpg",
            "/photos/lochs-and-glens-way/09.jpg",
            "/photos/lochs-and-glens-way/10.jpg",
            "/photos/lochs-and-glens-way/11.jpg",
            "/photos/lochs-and-glens-way/12.jpg",
            "/photos/lochs-and-glens-way/13.jpg",
            "/photos/lochs-and-glens-way/14.jpg",
            "/photos/lochs-and-glens-way/15.jpg",
            "/photos/lochs-and-glens-way/16.jpg",
            "/photos/lochs-and-glens-way/17.jpg",
            "/photos/lochs-and-glens-way/18.jpg",
            "/photos/lochs-and-glens-way/19.jpg",
            "/photos/lochs-and-glens-way/20.jpg",
            "/photos/lochs-and-glens-way/21.jpg",
            "/photos/lochs-and-glens-way/22.jpg",
            "/photos/lochs-and-glens-way/23.jpg",
            "/photos/lochs-and-glens-way/24.jpg",
            "/photos/lochs-and-glens-way/25.jpg",
            "/photos/lochs-and-glens-way/26.jpg",
            "/photos/lochs-and-glens-way/27.jpg",
            "/photos/lochs-and-glens-way/28.jpg",
            "/photos/lochs-and-glens-way/29.jpg",
            "/photos/lochs-and-glens-way/30.jpg",
            "/photos/lochs-and-glens-way/31.jpg",
            "/photos/lochs-and-glens-way/32.jpg",
            "/photos/lochs-and-glens-way/33.jpg",
            "/photos/lochs-and-glens-way/34.jpg",
            "/photos/lochs-and-glens-way/35.jpg",
            "/photos/lochs-and-glens-way/36.jpg",
            "/photos/lochs-and-glens-way/37.jpg",
            "/photos/lochs-and-glens-way/38.jpg",
            "/photos/lochs-and-glens-way/39.jpg",
            "/photos/lochs-and-glens-way/40.jpg",
            "/photos/lochs-and-glens-way/41.jpg",
            "/photos/lochs-and-glens-way/42.jpg",
            "/photos/lochs-and-glens-way/43.jpg",
            "/photos/lochs-and-glens-way/44.jpg",
            "/photos/lochs-and-glens-way/45.jpg",
            "/photos/lochs-and-glens-way/46.jpg",
            "/photos/lochs-and-glens-way/47.jpg",
            "/photos/lochs-and-glens-way/48.jpg",
            "/photos/lochs-and-glens-way/49.jpg",
            "/photos/lochs-and-glens-way/50.jpg",
            "/photos/lochs-and-glens-way/51.jpg",
            "/photos/lochs-and-glens-way/52.jpg",
            "/photos/lochs-and-glens-way/53.jpg",
            "/photos/lochs-and-glens-way/54.jpg",
            "/photos/lochs-and-glens-way/55.jpg",
            "/photos/lochs-and-glens-way/56.jpg",
            "/photos/lochs-and-glens-way/57.jpg",
            "/photos/lochs-and-glens-way/58.jpg",
            "/photos/lochs-and-glens-way/59.jpg",
            "/photos/lochs-and-glens-way/60.jpg",
            "/photos/lochs-and-glens-way/61.jpg",
            "/photos/lochs-and-glens-way/62.jpg",
            "/photos/lochs-and-glens-way/63.jpg",
            "/photos/lochs-and-glens-way/64.jpg",
            "/photos/lochs-and-glens-way/65.jpg",
            "/photos/lochs-and-glens-way/66.jpg",
            "/photos/lochs-and-glens-way/67.jpg",
            "/photos/lochs-and-glens-way/68.jpg",
            "/photos/lochs-and-glens-way/69.jpg",
            "/photos/lochs-and-glens-way/70.jpg",
            "/photos/lochs-and-glens-way/71.jpg",
            "/photos/lochs-and-glens-way/72.jpg",
            "/photos/lochs-and-glens-way/73.jpg",
            "/photos/lochs-and-glens-way/74.jpg",
            "/photos/lochs-and-glens-way/75.jpg",
            "/photos/lochs-and-glens-way/76.jpg",
            "/photos/lochs-and-glens-way/77.jpg",
            "/photos/lochs-and-glens-way/78.jpg",
            "/photos/lochs-and-glens-way/79.jpg",
            "/photos/lochs-and-glens-way/80.jpg",
            "/photos/lochs-and-glens-way/81.jpg",
            "/photos/lochs-and-glens-way/82.jpg",
            "/photos/lochs-and-glens-way/83.jpg",
            "/photos/lochs-and-glens-way/84.jpg",
            "/photos/lochs-and-glens-way/85.jpg",
            "/photos/lochs-and-glens-way/86.jpg",
            "/photos/lochs-and-glens-way/87.jpg",
            "/photos/lochs-and-glens-way/88.jpg",
            "/photos/lochs-and-glens-way/89.jpg",
            "/photos/lochs-and-glens-way/90.jpg",
            "/photos/lochs-and-glens-way/91.jpg",
            "/photos/lochs-and-glens-way/92.jpg",
        ],
    },
    {
        id: "loch-katrine",
        title: "Loch Katrine",
        subtitle: "Cycling from Stirling",
        date: "Jul 2026",
        photos: [
            "/photos/loch-katrine/01.jpg",
            "/photos/loch-katrine/02.jpg",
            "/photos/loch-katrine/03.jpg",
            "/photos/loch-katrine/04.jpg",
            "/photos/loch-katrine/05.jpg",
            "/photos/loch-katrine/06.jpg",
            "/photos/loch-katrine/07.jpg",
            "/photos/loch-katrine/08.jpg",
            "/photos/loch-katrine/09.jpg",
            "/photos/loch-katrine/10.jpg",
            "/photos/loch-katrine/11.jpg",
            "/photos/loch-katrine/12.jpg",
            "/photos/loch-katrine/13.jpg",
            "/photos/loch-katrine/14.jpg",
            "/photos/loch-katrine/15.jpg",
            "/photos/loch-katrine/16.jpg",
            "/photos/loch-katrine/17.jpg",
            "/photos/loch-katrine/18.jpg",
            "/photos/loch-katrine/19.jpg",
            "/photos/loch-katrine/20.jpg",
            "/photos/loch-katrine/21.jpg",
            "/photos/loch-katrine/22.jpg",
            "/photos/loch-katrine/23.jpg",
            "/photos/loch-katrine/24.jpg",
            "/photos/loch-katrine/25.jpg",
        ],
    },
    {
        id: "cambridge",
        title: "Cambridge",
        subtitle: "England",
        date: "May 2026",
        photos: [
            "/photos/cambridge/01.jpg",
            "/photos/cambridge/02.jpg",
            "/photos/cambridge/03.jpg",
            "/photos/cambridge/04.jpg",
            "/photos/cambridge/05.jpg",
            "/photos/cambridge/06.jpg",
            "/photos/cambridge/07.jpg",
            "/photos/cambridge/08.jpg",
            "/photos/cambridge/09.jpg",
            "/photos/cambridge/10.jpg",
            "/photos/cambridge/11.jpg",
        ],
    },
    {
        id: "hermitage",
        title: "The Hermitage",
        subtitle: "Dunkeld",
        date: "Apr 2026",
        photos: [
            "/photos/hermitage/01.jpg",
            "/photos/hermitage/02.jpg",
            "/photos/hermitage/03.jpg",
            "/photos/hermitage/04.jpg",
            "/photos/hermitage/05.jpg",
            "/photos/hermitage/06.jpg",
            "/photos/hermitage/07.jpg",
            "/photos/hermitage/08.jpg",
            "/photos/hermitage/09.jpg",
            "/photos/hermitage/10.jpg",
            "/photos/hermitage/11.jpg",
            "/photos/hermitage/12.jpg",
            "/photos/hermitage/13.jpg",
            "/photos/hermitage/14.jpg",
            "/photos/hermitage/15.jpg",
            "/photos/hermitage/16.jpg",
            "/photos/hermitage/17.jpg",
            "/photos/hermitage/18.jpg",
            "/photos/hermitage/19.jpg",
            "/photos/hermitage/20.jpg",
            "/photos/hermitage/21.jpg",
            "/photos/hermitage/22.jpg",
            "/photos/hermitage/23.jpg",
            "/photos/hermitage/24.jpg",
            "/photos/hermitage/25.jpg",
            "/photos/hermitage/26.jpg",
            "/photos/hermitage/27.jpg",
            "/photos/hermitage/28.jpg",
            "/photos/hermitage/29.jpg",
            "/photos/hermitage/30.jpg",
            "/photos/hermitage/31.jpg",
            "/photos/hermitage/32.jpg",
            "/photos/hermitage/33.jpg",
            "/photos/hermitage/34.jpg",
            "/photos/hermitage/35.jpg",
            "/photos/hermitage/36.jpg",
            "/photos/hermitage/37.jpg",
            "/photos/hermitage/38.jpg",
            "/photos/hermitage/39.jpg",
            "/photos/hermitage/40.jpg",
            "/photos/hermitage/41.jpg",
            "/photos/hermitage/42.jpg",
        ],
    },
    {
        id: "glen-sannox",
        title: "Glen Sannox",
        subtitle: "Isle of Arran",
        date: "Apr 2026",
        photos: [
            "/photos/glen-sannox/01.jpg",
            "/photos/glen-sannox/02.jpg",
            "/photos/glen-sannox/03.jpg",
            "/photos/glen-sannox/04.jpg",
            "/photos/glen-sannox/05.jpg",
            "/photos/glen-sannox/06.jpg",
            "/photos/glen-sannox/07.jpg",
            "/photos/glen-sannox/08.jpg",
            "/photos/glen-sannox/09.jpg",
        ],
    },
    {
        id: "arosa",
        title: "Arosa",
        subtitle: "Switzerland",
        date: "Feb 2026",
        photos: [
            "/photos/arosa/01.jpg",
            "/photos/arosa/02.jpg",
            "/photos/arosa/03.jpg",
            "/photos/arosa/04.jpg",
            "/photos/arosa/05.jpg",
            "/photos/arosa/06.jpg",
            "/photos/arosa/07.jpg",
            "/photos/arosa/08.jpg",
            "/photos/arosa/09.jpg",
            "/photos/arosa/10.jpg",
            "/photos/arosa/11.jpg",
        ],
    },
    {
        id: "austria",
        title: "Austria",
        date: "Dec 2025",
        photos: [
            "/photos/austria/01.jpg",
            "/photos/austria/02.jpg",
            "/photos/austria/03.jpg",
            "/photos/austria/04.jpg",
            "/photos/austria/05.jpg",
            "/photos/austria/06.jpg",
            "/photos/austria/07.jpg",
            "/photos/austria/08.jpg",
            "/photos/austria/09.jpg",
            "/photos/austria/10.jpg",
            "/photos/austria/11.jpg",
            "/photos/austria/12.jpg",
            "/photos/austria/13.jpg",
            "/photos/austria/14.jpg",
            "/photos/austria/15.jpg",
            "/photos/austria/16.jpg",
            "/photos/austria/17.jpg",
            "/photos/austria/18.jpg",
            "/photos/austria/19.jpg",
        ],
    },
    {
        id: "barcelona",
        title: "Barcelona",
        subtitle: "Spain",
        date: "Nov 2025",
        photos: [
            "/photos/barcelona/01.jpg",
            "/photos/barcelona/02.jpg",
            "/photos/barcelona/03.jpg",
            "/photos/barcelona/04.jpg",
            "/photos/barcelona/05.jpg",
            "/photos/barcelona/06.jpg",
            "/photos/barcelona/07.jpg",
            "/photos/barcelona/08.jpg",
            "/photos/barcelona/09.jpg",
            "/photos/barcelona/10.jpg",
            "/photos/barcelona/11.jpg",
            "/photos/barcelona/12.jpg",
            "/photos/barcelona/13.jpg",
            "/photos/barcelona/14.jpg",
            "/photos/barcelona/15.jpg",
            "/photos/barcelona/16.jpg",
            "/photos/barcelona/17.jpg",
            "/photos/barcelona/18.jpg",
            "/photos/barcelona/19.jpg",
            "/photos/barcelona/20.jpg",
            "/photos/barcelona/21.jpg",
            "/photos/barcelona/22.jpg",
            "/photos/barcelona/23.jpg",
            "/photos/barcelona/24.jpg",
            "/photos/barcelona/25.jpg",
            "/photos/barcelona/26.jpg",
            "/photos/barcelona/27.jpg",
            "/photos/barcelona/28.jpg",
            "/photos/barcelona/29.jpg",
            "/photos/barcelona/30.jpg",
            "/photos/barcelona/31.jpg",
            "/photos/barcelona/32.jpg",
            "/photos/barcelona/33.jpg",
            "/photos/barcelona/34.jpg",
            "/photos/barcelona/35.jpg",
        ],
    },
    {
        id: "cycle-route-7",
        title: "Glen Ogle and the Three Lochs",
        subtitle: "Cycling from Stirling—Pitlochry",
        date: "Aug 2025",
        photos: [
            "/photos/cycle-route-7/01.jpg",
            "/photos/cycle-route-7/02.jpg",
            "/photos/cycle-route-7/03.jpg",
            "/photos/cycle-route-7/04.jpg",
            "/photos/cycle-route-7/05.jpg",
            "/photos/cycle-route-7/06.jpg",
            "/photos/cycle-route-7/07.jpg",
            "/photos/cycle-route-7/08.jpg",
            "/photos/cycle-route-7/09.jpg",
            "/photos/cycle-route-7/10.jpg",
            "/photos/cycle-route-7/11.jpg",
            "/photos/cycle-route-7/12.jpg",
            "/photos/cycle-route-7/13.jpg",
            "/photos/cycle-route-7/14.jpg",
            "/photos/cycle-route-7/15.jpg",
            "/photos/cycle-route-7/16.jpg",
            "/photos/cycle-route-7/17.jpg",
            "/photos/cycle-route-7/18.jpg",
            "/photos/cycle-route-7/19.jpg",
            "/photos/cycle-route-7/20.jpg",
            "/photos/cycle-route-7/21.jpg",
        ],
    },
    {
        id: "bute",
        title: "Isle of Bute",
        subtitle: "Argyll & Bute",
        date: "Jun 2025",
        photos: [
            "/photos/bute/01.jpg",
            "/photos/bute/02.jpg",
            "/photos/bute/03.jpg",
            "/photos/bute/04.jpg",
            "/photos/bute/05.jpg",
            "/photos/bute/06.jpg",
            "/photos/bute/07.jpg",
            "/photos/bute/08.jpg",
            "/photos/bute/09.jpg",
            "/photos/bute/10.jpg",
            "/photos/bute/11.jpg",
            "/photos/bute/12.jpg",
            "/photos/bute/13.jpg",
            "/photos/bute/14.jpg",
            "/photos/bute/15.jpg",
            "/photos/bute/16.jpg",
            "/photos/bute/17.jpg",
            "/photos/bute/18.jpg",
            "/photos/bute/19.jpg",
            "/photos/bute/20.jpg",
            "/photos/bute/21.jpg",
            "/photos/bute/22.jpg",
            "/photos/bute/23.jpg",
            "/photos/bute/24.jpg",
            "/photos/bute/25.jpg",
            "/photos/bute/26.jpg",
            "/photos/bute/27.jpg",
            "/photos/bute/28.jpg",
            "/photos/bute/29.jpg",
            "/photos/bute/30.jpg",
            "/photos/bute/31.jpg",
        ],
    },
    {
        id: "glen-rosa",
        title: "Glen Rosa & Goat Fell",
        subtitle: "Isle of Arran",
        date: "Jun 2025",
        photos: [
            "/photos/glen-rosa/01.jpg",
            "/photos/glen-rosa/02.jpg",
            "/photos/glen-rosa/03.jpg",
            "/photos/glen-rosa/04.jpg",
            "/photos/glen-rosa/05.jpg",
            "/photos/glen-rosa/06.jpg",
            "/photos/glen-rosa/07.jpg",
            "/photos/glen-rosa/08.jpg",
            "/photos/glen-rosa/09.jpg",
            "/photos/glen-rosa/10.jpg",
            "/photos/glen-rosa/11.jpg",
            "/photos/glen-rosa/12.jpg",
            "/photos/glen-rosa/13.jpg",
            "/photos/glen-rosa/14.jpg",
            "/photos/glen-rosa/15.jpg",
            "/photos/glen-rosa/16.jpg",
            "/photos/glen-rosa/17.jpg",
            "/photos/glen-rosa/18.jpg",
            "/photos/glen-rosa/19.jpg",
            "/photos/glen-rosa/20.jpg",
            "/photos/glen-rosa/21.jpg",
            "/photos/glen-rosa/22.jpg",
            "/photos/glen-rosa/23.jpg",
            "/photos/glen-rosa/24.jpg",
            "/photos/glen-rosa/25.jpg",
            "/photos/glen-rosa/26.jpg",
            "/photos/glen-rosa/27.jpg",
            "/photos/glen-rosa/28.jpg",
            "/photos/glen-rosa/29.jpg",
            "/photos/glen-rosa/30.jpg",
            "/photos/glen-rosa/31.jpg",
            "/photos/glen-rosa/32.jpg",
        ],
    },
    {
        id: "brodick-lochranza",
        title: "Cock of Arran",
        subtitle: "Isle of Arran",
        date: "Jun 2025",
        photos: [
            "/photos/brodick-lochranza/01.jpg",
            "/photos/brodick-lochranza/02.jpg",
            "/photos/brodick-lochranza/03.jpg",
            "/photos/brodick-lochranza/04.jpg",
            "/photos/brodick-lochranza/05.jpg",
            "/photos/brodick-lochranza/06.jpg",
            "/photos/brodick-lochranza/07.jpg",
            "/photos/brodick-lochranza/08.jpg",
            "/photos/brodick-lochranza/09.jpg",
            "/photos/brodick-lochranza/10.jpg",
            "/photos/brodick-lochranza/11.jpg",
            "/photos/brodick-lochranza/12.jpg",
            "/photos/brodick-lochranza/13.jpg",
            "/photos/brodick-lochranza/14.jpg",
            "/photos/brodick-lochranza/15.jpg",
            "/photos/brodick-lochranza/16.jpg",
        ],
    },
    {
        id: "tarbet-alexandria",
        title: "Loch Lomond West Bank",
        subtitle: "Cycling from Tarbet—Alexandria",
        date: "May 2025",
        photos: [
            "/photos/tarbet-alexandria/01.jpg",
            "/photos/tarbet-alexandria/02.jpg",
            "/photos/tarbet-alexandria/03.jpg",
            "/photos/tarbet-alexandria/04.jpg",
            "/photos/tarbet-alexandria/05.jpg",
            "/photos/tarbet-alexandria/06.jpg",
            "/photos/tarbet-alexandria/07.jpg",
            "/photos/tarbet-alexandria/08.jpg",
            "/photos/tarbet-alexandria/09.jpg",
        ],
    },
    {
        id: "ben-more",
        title: "Ben More",
        subtitle: "Crianlarich",
        date: "Apr 2025",
        photos: [
            "/photos/ben-more/01.jpg",
            "/photos/ben-more/02.jpg",
            "/photos/ben-more/03.jpg",
            "/photos/ben-more/04.jpg",
            "/photos/ben-more/05.jpg",
            "/photos/ben-more/06.jpg",
            "/photos/ben-more/07.jpg",
            "/photos/ben-more/08.jpg",
            "/photos/ben-more/09.jpg",
            "/photos/ben-more/10.jpg",
            "/photos/ben-more/11.jpg",
            "/photos/ben-more/12.jpg",
            "/photos/ben-more/13.jpg",
            "/photos/ben-more/14.jpg",
            "/photos/ben-more/15.jpg",
        ],
    },
    {
        id: "ben-arthur",
        title: "Ben Arthur",
        subtitle: "Argyll & Bute",
        date: "Mar 2025",
        photos: [
            "/photos/ben-arthur/01.jpg",
            "/photos/ben-arthur/02.jpg",
            "/photos/ben-arthur/03.jpg",
            "/photos/ben-arthur/04.jpg",
            "/photos/ben-arthur/05.jpg",
            "/photos/ben-arthur/06.jpg",
            "/photos/ben-arthur/07.jpg",
            "/photos/ben-arthur/08.jpg",
            "/photos/ben-arthur/09.jpg",
            "/photos/ben-arthur/10.jpg",
            "/photos/ben-arthur/11.jpg",
        ],
    },
    {
        id: "fife-coastal-path",
        title: "Fife Coastal Path",
        subtitle: "Cycling from Alloa—North Queensferry",
        date: "Feb 2025",
        photos: [
            "/photos/fife-coastal-path/01.jpg",
            "/photos/fife-coastal-path/02.jpg",
            "/photos/fife-coastal-path/03.jpg",
            "/photos/fife-coastal-path/04.jpg",
            "/photos/fife-coastal-path/05.jpg",
            "/photos/fife-coastal-path/06.jpg",
            "/photos/fife-coastal-path/07.jpg",
            "/photos/fife-coastal-path/08.jpg",
            "/photos/fife-coastal-path/09.jpg",
            "/photos/fife-coastal-path/10.jpg",
            "/photos/fife-coastal-path/11.jpg",
        ],
    },
    {
        id: "river-garry",
        title: "River Garry",
        subtitle: "Perthshire",
        date: "Feb 2025",
        photos: [
            "/photos/river-garry/01.jpg",
            "/photos/river-garry/02.jpg",
            "/photos/river-garry/03.jpg",
            "/photos/river-garry/04.jpg",
            "/photos/river-garry/05.jpg",
            "/photos/river-garry/06.jpg",
            "/photos/river-garry/07.jpg",
            "/photos/river-garry/08.jpg",
            "/photos/river-garry/09.jpg",
            "/photos/river-garry/10.jpg",
            "/photos/river-garry/11.jpg",
            "/photos/river-garry/12.jpg",
            "/photos/river-garry/13.jpg",
            "/photos/river-garry/14.jpg",
            "/photos/river-garry/15.jpg",
        ],
    },
    {
        id: "falls-of-clyde",
        title: "Falls of Clyde",
        subtitle: "Lanark",
        date: "Feb 2025",
        photos: [
            "/photos/falls-of-clyde/01.jpg",
            "/photos/falls-of-clyde/02.jpg",
            "/photos/falls-of-clyde/03.jpg",
            "/photos/falls-of-clyde/04.jpg",
            "/photos/falls-of-clyde/05.jpg",
            "/photos/falls-of-clyde/06.jpg",
            "/photos/falls-of-clyde/07.jpg",
            "/photos/falls-of-clyde/08.jpg",
            "/photos/falls-of-clyde/09.jpg",
            "/photos/falls-of-clyde/10.jpg",
            "/photos/falls-of-clyde/11.jpg",
            "/photos/falls-of-clyde/12.jpg",
            "/photos/falls-of-clyde/13.jpg",
            "/photos/falls-of-clyde/14.jpg",
            "/photos/falls-of-clyde/15.jpg",
            "/photos/falls-of-clyde/16.jpg",
            "/photos/falls-of-clyde/17.jpg",
            "/photos/falls-of-clyde/18.jpg",
            "/photos/falls-of-clyde/19.jpg",
            "/photos/falls-of-clyde/20.jpg",
            "/photos/falls-of-clyde/21.jpg",
            "/photos/falls-of-clyde/22.jpg",
            "/photos/falls-of-clyde/23.jpg",
            "/photos/falls-of-clyde/24.jpg",
            "/photos/falls-of-clyde/25.jpg",
            "/photos/falls-of-clyde/26.jpg",
        ],
    },
    {
        id: "campsie-glen",
        title: "Campsie Glen",
        subtitle: "East Dumbartonshire",
        date: "Dec 2024",
        photos: [
            "/photos/campsie-glen/01.jpg",
            "/photos/campsie-glen/02.jpg",
            "/photos/campsie-glen/03.jpg",
            "/photos/campsie-glen/04.jpg",
            "/photos/campsie-glen/05.jpg",
            "/photos/campsie-glen/06.jpg",
            "/photos/campsie-glen/07.jpg",
            "/photos/campsie-glen/08.jpg",
            "/photos/campsie-glen/09.jpg",
            "/photos/campsie-glen/10.jpg",
        ],
    },
    {
        id: "dumyat",
        title: "Dumyat",
        subtitle: "Stirling",
        date: "Nov 2024",
        photos: [
            "/photos/dumyat/01.jpg",
            "/photos/dumyat/02.jpg",
            "/photos/dumyat/03.jpg",
            "/photos/dumyat/04.jpg",
            "/photos/dumyat/05.jpg",
            "/photos/dumyat/06.jpg",
            "/photos/dumyat/07.jpg",
            "/photos/dumyat/08.jpg",
            "/photos/dumyat/09.jpg",
        ],
    },
];
